export enum MessageListItemType {
	NSC,
	Instant,
	Login,
	Mofid,
	Codal
}

export enum MessageListItemContentType {
	ArzeAvalie = 1,
	Goshayesh = 2,
	TavaghofNamad = 3,
	PazireNevisi = 4,
	DamaneMojaz = 5,
	Omde = 6,
	SarResid = 7,
	BazGoshayi = 8,
	Ettelaeeye = 9,
	Bazargardani = 10,
	Haraj = 11,
	RafeeGere = 12,
	Other = 1000,
	EstefadeNashode = 1001,
	Maskan = 1002
}

export enum CodalSourceType {
	URL,
	PDF,
	EXC,
	ATT
}

export interface MessageFilterCriteria {
	from: Date;
	to: Date;
	type?: MessageListItemType;
	isin?: string;
}

export interface MofidMessageListItem {
	id: string;
	imageId: string;
	messageId: string;
	date: Date;
	createDateTime: Date;
	title: string;
	body: string;
	isRead: boolean;
	route: string;
	url: string;
	isins: string[];
}

export interface CodalMessageListItem {
	no: number;
	date: string;
	title: string;
	url: string;
	pdf: string;
	exc: string;
	att: string;
}

export interface CodalSourceListItem {
	type: CodalSourceType;
	url: string;
}

export type CodalSourceList = CodalSourceListItem[];

export interface MessageListItem {
	id: string;
	title: string;
	date: Date;
	createDateTime: Date;
	isins: string[];
	type: MessageListItemType;
	contentType: MessageListItemContentType;
	isToday: boolean;

	// Just codal don't have
	body: string;

	// Just Codal message have
	sources: CodalSourceList;

	// Just Mofid message
	url: string;
	route: string;
	imageId: string;

	// For UI Interaction
	showDetails: boolean;
}

export type MessageListItemImage = { imageId: string; data: string };

export type MessageList = MessageListItem[];

export type MessageListKeyValue = { [key: string]: MessageList };
